import { PaStatus, PaStatusLabels } from "../../../../enums/paStatus";
import {
  PENDING_WITH_INSURANCE_OUTCOME_LABEL,
  RISA_IN_PROGRESS_OUTCOME_LABEL,
} from "../../table/utils/getAsteraOutcomeDisplayText";

/** Empty string filter value matches null/empty response_status in BigQuery. */
const RISA_IN_PROGRESS_FILTER_VALUE = "";

export const allPaStatusOptions = [
  {
    label: RISA_IN_PROGRESS_OUTCOME_LABEL,
    value: RISA_IN_PROGRESS_FILTER_VALUE,
  },
  {
    label: PENDING_WITH_INSURANCE_OUTCOME_LABEL,
    value: PaStatus.PENDING,
  },
  { label: PaStatusLabels[PaStatus.APPROVED], value: PaStatus.APPROVED },
  { label: PaStatusLabels[PaStatus.DENIED], value: PaStatus.DENIED },
  {
    label: PaStatusLabels[PaStatus.AUTH_NOT_REQUIRED],
    value: PaStatus.AUTH_NOT_REQUIRED,
  },
  {
    label: PaStatusLabels[PaStatus.ONSHORE_ASSISTANCE],
    value: PaStatus.ONSHORE_ASSISTANCE,
  },
  { label: PaStatusLabels[PaStatus.NA_OUTCOME], value: PaStatus.NA_OUTCOME },
];
